import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';
import { GetContactReasonResponseItem } from '../../contact-reason/service/models/contact-reason.service.model';
import {
  CreateUpdateClientRequest,
  GetClientRequest,
  GetClientsResponse,
  PagedGetClientsResponse,
} from '../models/client.model';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly baseURL: string = `${environment.apiUrl}/api/Client`;

  constructor(private readonly http: HttpClient) {}

  get(
    filter: GetClientRequest | null = null
  ): Observable<PagedGetClientsResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<PagedGetClientsResponse>(this.baseURL, { params });
  }

  getById(id: string): Observable<GetClientsResponse> {
    return this.http.get<GetClientsResponse>(this.baseURL + '/' + id);
  }

  getContactReasons(id: string): Observable<GetContactReasonResponseItem> {
    return this.http.get<GetContactReasonResponseItem>(
      this.baseURL + '/' + id + '/Contact-Reason'
    );
  }

  create(request: CreateUpdateClientRequest) {
    return this.http.post(this.baseURL, request);
  }

  update(id: string, request: CreateUpdateClientRequest) {
    return this.http.put(this.baseURL + '/' + id, request);
  }
}
